import React from 'react';
import { Form, Input, Select, Radio } from 'antd';
import { PhoneOutlined, MessageOutlined, MailOutlined } from '@ant-design/icons';

const { Option } = Select;

const Section02Contact = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 02</span>
        <h3>Contact Information</h3>
        <p className="section-description">
          We use this information to send course credentials, live class schedules, assessment results, and certificate notifications.
        </p>
      </div>

      <div className="form-grid">
        <div className="grid-two-cols">
          <Form.Item
            label="Primary Contact Number"
            name="primaryContact"
            rules={[
              { required: true, message: 'Please enter your primary contact number' },
              { pattern: /^[0-9+-\s()]{9,15}$/, message: 'Please enter a valid phone number' }
            ]}
          >
            <Input prefix={<PhoneOutlined />} placeholder="e.g. 0771234567 or +94 77 123 4567" size="large" />
          </Form.Item>

          <Form.Item
            label="WhatsApp Number"
            name="whatsappNumber"
            rules={[
              { required: true, message: 'Please enter your WhatsApp number' },
              { pattern: /^[0-9+-\s()]{9,15}$/, message: 'Please enter a valid phone number' }
            ]}
            extra="Essential for batch coordination and live class updates"
          >
            <Input prefix={<MessageOutlined style={{ color: '#25D366' }} />} placeholder="e.g. 0771234567" size="large" />
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: 'Please enter your email address' },
              { type: 'email', message: 'Please enter a valid email address' }
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="e.g. student@gmail.com" size="large" />
          </Form.Item>

          <Form.Item
            label="Secondary Contact Number (Optional)"
            name="secondaryContact"
            rules={[{ pattern: /^[0-9+-\s()]{9,15}$/, message: 'Please enter a valid phone number' }]}
          >
            <Input prefix={<PhoneOutlined />} placeholder="e.g. Home or alternate mobile" size="large" />
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item
            label="Preferred Communication Method"
            name="preferredCommunication"
            rules={[{ required: true, message: 'Please select your preferred communication channel' }]}
            initialValue="whatsapp"
          >
            <Radio.Group buttonStyle="solid" size="large" className="contact-channel-radios">
              <Radio.Button value="whatsapp">
                <MessageOutlined style={{ color: '#25D366', marginRight: 6 }} /> WhatsApp
              </Radio.Button>
              <Radio.Button value="phone_call">
                <PhoneOutlined style={{ marginRight: 6 }} /> Phone Call
              </Radio.Button>
              <Radio.Button value="email">
                <MailOutlined style={{ marginRight: 6 }} /> Email
              </Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="Preferred Contact Time (Optional)" name="preferredContactTime">
            <Select size="large" placeholder="Select best time to contact you">
              <Option value="morning">Morning (9:00 AM – 12:00 PM)</Option>
              <Option value="afternoon">Afternoon (12:00 PM – 4:00 PM)</Option>
              <Option value="evening">Evening (4:00 PM – 8:00 PM)</Option>
              <Option value="weekend">Weekends Only</Option>
              <Option value="anytime">Anytime during working hours</Option>
            </Select>
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default Section02Contact;
